import React from 'react';
import './Navbar.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../image/logo.png'

function NavBar() {
  return (
    <Navbar bg="light" variant="light" className="custom-navbar" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/" className='title'>
          <img src={logo} alt='logo' className='logo'/>
          Koru AI
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav" className='justify-content-center'>
          <Nav className="align-items-center custom-nav-links">
            <Nav.Link href="/" className='custom-nav'>Home</Nav.Link>
            <Nav.Link href="/category" className='custom-nav'>Category</Nav.Link>
            <Nav.Link href="/about" className='custom-nav'>About</Nav.Link>
            <Nav.Link href="/contact" className='custom-nav'>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;